// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.baloa-play-match-payment-extra-clips-modal .modal__container {
    max-width: unset;
    width: 507px;
    padding: 55px 44px 24px 44px;
}   

.baloa-play-match-payment-extra-clips-modal__container {
    text-align: center;
}

.baloa-play-match-payment-extra-clips-modal .modal__container__close {
    right: 20px;
    top: 14px;
}

.baloa-play-match-payment-extra-clips-modal .modal__container__close img {
    width: 16px;
    height: 16px;
}


.baloa-play-match-payment-extra-clips-modal__header {
    padding: 12px;
    background: var(--new-informative-banner-bg-color);
    border-radius: 8px;
}

.baloa-play-match-payment-extra-clips-modal__option-header__title .hubicon-video_library::before {
    font-size: 24px;
    color: #0D6EFD;
    margin-right: 4px;
}

.baloa-play-match-payment-extra-clips-modal__container .baloa-names,
.baloa-play-match-payment-extra-clips-modal__container .baloa-table {
    color: var(--primary-very-dark-color);
}

.baloa-play-match-payment-extra-clips-modal__container .baloa-table.subtitle {
    margin-top: 24px;
    margin-bottom: 60px;
}

.baloa-play-match-payment-extra-clips-modal__container .baloa-names.subtitle {
    margin-top: 36px;
}

.baloa-play-match-payment-extra-clips-modal__container .sum-rest-input  {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
}

.baloa-play-match-payment-extra-clips-modal__option-container {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    margin-top: 24px;
    text-align: left;
    cursor: pointer;
}

.baloa-play-match-payment-extra-clips-modal__option-container:last-of-type {
    margin-top: 16px;
}

.baloa-play-match-payment-extra-clips-modal__option-container .baloa-table.lista {
    margin-top: 8px;
    display: list-item;
    list-style: disc;
    list-style-position: inside;

}

.baloa-play-match-payment-extra-clips-modal__option-container .baloa-table.lista2 {
    margin-top: 8px;
    display: list-item;
    list-style: disc;
    list-style-position: inside;
    padding-left: 10px;
}

.baloa-play-match-payment-extra-clips-modal__option-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.baloa-play-match-payment-extra-clips-modal__option-header .baloa-names.price {
    font-weight: var(--font-bold);
}

.baloa-play-match-payment-extra-clips-modal__option-header__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.baloa-play-match-payment-extra-clips-modal__option-header__title .baloa-names.resumen {
    font-weight: var(--font-regular);
    margin-right: 4px;
}

.baloa-play-match-payment-extra-clips-modal__option-header__title .hubicon-dashboard_customize::before{
    font-size: 22px;
    color: #6EA8FE;
    margin-right: 4px;
}

.baloa-play-match-payment-extra-clips-modal__option-counter {
    padding: 12px;
    background: var(--new-informative-banner-bg-color);
    border-radius: 8px;
    margin-top: 12px;
    text-align: center;
}

.baloa-play-match-payment-extra-clips-modal__option-counter .hubicon-info::before {
    font-size: 18px;
    color: var(--new-informative-banner-color);
}

.baloa-play-match-payment-extra-clips-modal__option-counter .baloa-table-column {
    font-weight: var(--font-regular);
}

.baloa-play-match-payment-extra-clips-modal__option-counter .baloa-table-column .counter {
    font-weight: var(--font-medium);
}

.baloa-play-match-payment-extra-clips-modal__option-counter__counter {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 16px;
}

.baloa-play-match-payment-extra-clips-modal__separator {
    border-bottom: 1px solid var(--new-gray-background-color);
    margin-top: 20px;
}

.baloa-play-match-payment-extra-clips-modal__option-total {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.baloa-play-match-payment-extra-clips-modal__option-total .baloa-subtitle2 {
    color: var(--primary-very-dark-color);
}

.baloa-play-match-payment-extra-clips-modal .button.primary-button {
    margin-top: 24px;
    width: 100%;    
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-play-match-payment-extra-clips-modal.modal {
        top: 0;
    }

    .baloa-play-match-payment-extra-clips-modal .modal__container__close {
        right: 12px;
    }

    .baloa-play-match-payment-extra-clips-modal .modal__container__close img {
        width: 14px;
        height: 14px;
    }

    .baloa-play-match-payment-extra-clips-modal .modal__container {
        padding: 40px 12px 8px 12px;
        margin: 0;
        width: 100%;
        border-radius: 0;
        height: 100vh;
    }

    .baloa-play-match-payment-extra-clips-modal__option-container .hubicon-award_star {
        font-size: 20px;
    }

    .baloa-play-match-payment-extra-clips-modal .button.primary-button {
        width: -webkit-fill-available;
        position: fixed;
        bottom: 12px;
        margin-right: 12px;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-match-payment-extra-clips-modal/BaloaPlayMatchPaymentExtraClipsModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;;AAE/B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yDAAyD;IACzD,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,MAAM;IACV;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,2BAA2B;QAC3B,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,YAAY;QACZ,kBAAkB;IACtB;;AAEJ","sourcesContent":["\n.baloa-play-match-payment-extra-clips-modal .modal__container {\n    max-width: unset;\n    width: 507px;\n    padding: 55px 44px 24px 44px;\n}   \n\n.baloa-play-match-payment-extra-clips-modal__container {\n    text-align: center;\n}\n\n.baloa-play-match-payment-extra-clips-modal .modal__container__close {\n    right: 20px;\n    top: 14px;\n}\n\n.baloa-play-match-payment-extra-clips-modal .modal__container__close img {\n    width: 16px;\n    height: 16px;\n}\n\n\n.baloa-play-match-payment-extra-clips-modal__header {\n    padding: 12px;\n    background: var(--new-informative-banner-bg-color);\n    border-radius: 8px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-header__title .hubicon-video_library::before {\n    font-size: 24px;\n    color: #0D6EFD;\n    margin-right: 4px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__container .baloa-names,\n.baloa-play-match-payment-extra-clips-modal__container .baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-match-payment-extra-clips-modal__container .baloa-table.subtitle {\n    margin-top: 24px;\n    margin-bottom: 60px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__container .baloa-names.subtitle {\n    margin-top: 36px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__container .sum-rest-input  {\n    width: 50%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-container {\n    padding: 16px;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    margin-top: 24px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-container:last-of-type {\n    margin-top: 16px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-container .baloa-table.lista {\n    margin-top: 8px;\n    display: list-item;\n    list-style: disc;\n    list-style-position: inside;\n\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-container .baloa-table.lista2 {\n    margin-top: 8px;\n    display: list-item;\n    list-style: disc;\n    list-style-position: inside;\n    padding-left: 10px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-header .baloa-names.price {\n    font-weight: var(--font-bold);\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-header__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-bottom: 12px;\n    margin-bottom: 12px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-header__title .baloa-names.resumen {\n    font-weight: var(--font-regular);\n    margin-right: 4px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-header__title .hubicon-dashboard_customize::before{\n    font-size: 22px;\n    color: #6EA8FE;\n    margin-right: 4px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-counter {\n    padding: 12px;\n    background: var(--new-informative-banner-bg-color);\n    border-radius: 8px;\n    margin-top: 12px;\n    text-align: center;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-counter .hubicon-info::before {\n    font-size: 18px;\n    color: var(--new-informative-banner-color);\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-counter .baloa-table-column {\n    font-weight: var(--font-regular);\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-counter .baloa-table-column .counter {\n    font-weight: var(--font-medium);\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-counter__counter {\n    width: 60%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 16px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__separator {\n    border-bottom: 1px solid var(--new-gray-background-color);\n    margin-top: 20px;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-total {\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.baloa-play-match-payment-extra-clips-modal__option-total .baloa-subtitle2 {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-match-payment-extra-clips-modal .button.primary-button {\n    margin-top: 24px;\n    width: 100%;    \n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-play-match-payment-extra-clips-modal.modal {\n        top: 0;\n    }\n\n    .baloa-play-match-payment-extra-clips-modal .modal__container__close {\n        right: 12px;\n    }\n\n    .baloa-play-match-payment-extra-clips-modal .modal__container__close img {\n        width: 14px;\n        height: 14px;\n    }\n\n    .baloa-play-match-payment-extra-clips-modal .modal__container {\n        padding: 40px 12px 8px 12px;\n        margin: 0;\n        width: 100%;\n        border-radius: 0;\n        height: 100vh;\n    }\n\n    .baloa-play-match-payment-extra-clips-modal__option-container .hubicon-award_star {\n        font-size: 20px;\n    }\n\n    .baloa-play-match-payment-extra-clips-modal .button.primary-button {\n        width: -webkit-fill-available;\n        position: fixed;\n        bottom: 12px;\n        margin-right: 12px;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
